import React, { useState, useEffect } from "react";
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import axios from "axios";
import { baseurladdress } from "../baseurl"
import { useNavigate } from "react-router-dom";
import moment from "moment";

const Swal = require('sweetalert2')
const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 1800,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})
export default function EditShifttool() {
    const accesstoken = localStorage.getItem("token");
    const [action, setAction] = useState("");
    const [branchtype, setBranchtype] = useState([]);
    const [shifttype, setshifttype] = useState([]);
    const [reqTableData, setReqTableData] = useState([]);
    const [selectedshifttype, selectedshifttypes] = useState("");
    const [periodFrom, setPeriodFrom] = useState("");
    const [periodTo, setPeriodTo] = useState("");
    const [selectedbranchtype, setSelectedBranchType] = useState('');
    const [selectedRequests, setSelectedRequests] = useState([]);
    const [noDataFound, setNoDataFound] = useState(false);
    const [selectedapprover, setselectedapprover] = useState("");
    const [cDropdown, setCDropdown] = useState(0);
    const [approvers, setApprovers] = useState([]);

    // getallbranches
    useEffect(() => {
        const getallbranchestype = () => {
            axios.get(baseurladdress + `getallbranchestype`, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
                .then(res => {
                    const data = res.data.response;
                    setBranchtype(data);
                })
                .catch(error => {
                    alert(error);
                });
        };
        getallbranchestype();
    }, []);


    // getallshifttypes
    useEffect(() => {
        const getshifttype = () => {
            axios.get(baseurladdress + `getallshifttype`, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
                .then(res => {
                    const data = res.data.response;
                    const type = data.map((item, index) => {
                        return (
                            <option value={item.type_id}> {item.type_name} </option>

                        )
                    }
                    );
                    setshifttype(type);
                }).catch(error => {
                    alert(error);
                })
        }
        getshifttype()
    }, [])


    // getallshiftapprovernames
    useEffect(() => {
        const roleId = localStorage.getItem("roleid");
        const staffId = Number(localStorage.getItem("staffid"));

        axios
            .get(baseurladdress + `getallshiftapproverscdrpdwn`, {
                headers: {
                    Authorization: `Bearer ${accesstoken}`,
                    "x-role-id": roleId,
                },
            })
            .then((res) => {
                const cdrop = Number(res.data.cdropdown);
                setCDropdown(cdrop);

                const approverList = res.data.approvers.map(a => ({
                    ...a,
                    shap_staffid: Number(a.shap_staffid)
                }));
                setApprovers(approverList);

                if (cdrop === 0) {
                    setselectedapprover(staffId);
                }
            })
            .catch((err) => console.error(err));
    }, []);





    // getallrequestsintotable
    const handleGetShiftRequests = (e) => {
        e.preventDefault();

        if (!selectedbranchtype && !selectedshifttype && !selectedapprover && !periodFrom && !periodTo) {
            Swal.fire({
                icon: 'warning',
                title: 'No Selection',
                text: 'Please select at least one field before searching.',
                confirmButtonColor: '#3085d6'
            });
            return;
        }
        const queryParams = {};
        if (selectedbranchtype) queryParams.branch_id = selectedbranchtype;
        if (selectedshifttype) queryParams.type_id = selectedshifttype;
        if (selectedapprover) queryParams.requested_to = selectedapprover;
        if (periodFrom) queryParams.date_from = periodFrom;
        if (periodTo) queryParams.date_to = periodTo;

        const queryString = new URLSearchParams(queryParams).toString();

        axios
            .get(baseurladdress + `getallshiftrequests?${queryString}`, {
                headers: {
                    Authorization: `Bearer ${accesstoken}`,
                },
            })
            .then(res => {
                const datas = res.data.response;
                if (datas && datas.length > 0) {
                    setReqTableData(datas);
                    setNoDataFound(false);
                } else {
                    setReqTableData([]);
                    setNoDataFound(true);
                    setSelectedBranchType("");
                    selectedshifttypes("");
                    setPeriodFrom("");
                    setPeriodTo("");
                }
            })

    };


    const handleCheckboxChange = (e, reqId) => {
        if (e.target.checked) {
            setSelectedRequests(prev => [...prev, reqId]);
        } else {
            setSelectedRequests(prev => prev.filter(id => id !== reqId));
        }
    };

    const handleProcessRequest = (e) => {
        e.preventDefault();

        if (selectedRequests.length === 0) {
            Toast.fire({
                icon: 'warning',
                title: 'No requests selected',
            });
            return;
        }

        Swal.fire({
            title: 'Process Requests',
            text: 'Do you want to approve or reject the selected requests?',
            icon: 'question',
            showDenyButton: true,
            confirmButtonText: 'Approve',
            denyButtonText: 'Reject',
        }).then((result) => {
            let statusValue = null;

            if (result.isConfirmed) statusValue = 5;
            else if (result.isDenied) statusValue = 0;

            if (statusValue !== null) {
                const payload = {
                    request_ids: selectedRequests,
                    status: statusValue,
                };

                axios
                    .post(`${baseurladdress}processshiftrequests`, payload, {
                        headers: {
                            Authorization: `Bearer ${accesstoken}`,
                        },
                    })
                    .then((res) => {
                        Toast.fire({
                            icon: 'success',
                            title: 'Requests processed successfully',
                        });

                        setSelectedRequests([]);
                        handleGetShiftRequests(e);
                    })
                    .catch((err) => {
                        Toast.fire({
                            icon: 'error',
                            title: 'Failed to process requests',
                        });
                    });
            }
        });
    };
    return (
        <>
            <Topnavbar />

            <Sidennav />
            <div className="content-wrap">
                <div className="row g-3">
                    <div className="col-12 ">
                        <div className="card h-100">
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <h4 className="card-title mb-0">Shift Assignment Tool</h4>
                                <button
                                    className="btn btn-success"
                                    style={{
                                        position: "fixed",
                                        bottom: "20px",
                                        right: "20px",
                                        zIndex: 1050,
                                        borderRadius: "50%",
                                        width: "60px",
                                        height: "60px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                                    }}
                                    onClick={handleProcessRequest}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="white" viewBox="0 0 24 24">
                                        <path d="M17 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7l-4-4zM12 17a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm2-8H7V5h7v4z" />
                                    </svg>
                                </button>

                            </div>
                            <div className="card-body">
                                <form >
                                    <div className="form-row">
                                        <div className="col-sm-4 mt-2">
                                            <h6>Action</h6>
                                            {/* <select
                                                className="form-control"
                                                value={action}
                                                onChange={(e) => setAction(e.target.value)}
                                            >
                                                <option value="" disabled>Select action</option>
                                                <option value="Process">Process Request</option>
                                            </select> */}
                                            <select
                                                className="form-control"
                                                value="Process"
                                                disabled
                                            >
                                                <option value="Process">Process Request</option>
                                            </select>
                                        </div>
                                        <div className="col-sm-4 mt-2">
                                            <h6>Branch</h6>
                                            <select
                                                className="form-control"
                                                value={selectedbranchtype}
                                                onChange={(e) => setSelectedBranchType(e.target.value)}
                                            >
                                                <option value="" disabled>Select branch</option>
                                                {branchtype.map((branch) => (
                                                    <option key={branch.branch_id} value={branch.branch_id}>
                                                        {branch.branch_name}
                                                    </option>
                                                ))}

                                            </select>

                                        </div>
                                        <div className="col-sm-4 mt-2">
                                            <h6>Shift Type</h6>
                                            <select
                                                className="form-control"
                                                value={selectedshifttype}
                                                onChange={(e) => selectedshifttypes(e.target.value)}

                                            >
                                                <option value="" disabled>Select shift type</option>
                                                {shifttype}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="form-row">
                                        <div className="col-sm-4 mt-3">
                                            <h6>Period From</h6>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={periodFrom}
                                                onChange={(e) => setPeriodFrom(e.target.value)}

                                            />
                                        </div>
                                        <div className="col-sm-4 mt-3">
                                            <h6>Period To</h6>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={periodTo}
                                                onChange={(e) => setPeriodTo(e.target.value)}

                                            />
                                        </div>
                                        <div className="col-sm-4 mt-3">
                                            <h6>Approver</h6>
                                            <select
                                                className="form-control"
                                                value={selectedapprover}
                                                onChange={(e) => setselectedapprover(e.target.value)}
                                                disabled={cDropdown === 0}
                                            >
                                                <option value="" disabled>Select Approver</option>

                                                {approvers
                                                    .filter(appr =>
                                                        cDropdown === 0
                                                            ? appr.shap_staffid === Number(localStorage.getItem("staffid"))
                                                            : true
                                                    )
                                                    .map(appr => (
                                                        <option key={appr.shap_staffid} value={appr.shap_staffid}>
                                                            {appr.shap_staffname}
                                                        </option>
                                                    ))}
                                            </select>


                                        </div>
                                    </div>

                                    <div className="form-row">
                                        <div className="col-12 mt-4">
                                            <button type="submit" className="btn btn-primary" onClick={handleGetShiftRequests}>
                                                Get Shift Requests
                                            </button>
                                        </div>
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="row g-3 mt-3">
                    <div className="col-12">
                        <table className="table table-bordered" >
                            <thead>
                                <tr style={{
                                    borderTop: "1px solid #bbb",
                                    borderBottom: "2px solid #bbb",
                                    textAlign: "left",
                                }}>
                                    <th>Select</th>
                                    <th>Req ID</th>
                                    <th>Staff name</th>
                                    <th>Department</th>
                                    <th>Branch</th>
                                    <th>Shift type</th>
                                    <th>From Date</th>
                                    <th>To Date</th>
                                    <th>Shift mode</th>
                                    <th style={{ textAlign: "left" }}>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {reqTableData.length > 0 ? (
                                    reqTableData.map((item, index) => (
                                        <tr key={index} style={{ textAlign: "left" }}>
                                            <td style={{ textAlign: "center" }}>
                                                <input
                                                    type="checkbox"
                                                    checked={selectedRequests.includes(item.req_id)}
                                                    onChange={(e) => handleCheckboxChange(e, item.req_id)}
                                                    disabled={item.status !== 1}  
                                                />
                                            </td>
                                            <td>{item.req_id}</td>
                                            <td>{item.emp_name}</td>
                                            <td>{item.dept_name}</td>
                                            <td>{item.branch_name}</td>
                                            <td>{item.type_name}</td>
                                            <td>{moment(item.date_from).format("DD-MM-YYYY")}</td>
                                            <td>{moment(item.date_to).format("DD-MM-YYYY")}</td>
                                            <td>{item.shift_mode}</td>
                                            <td style={{ textAlign: "left" }}>
                                                {item.status === 1 && <span className="badge bg-warning">Pending</span>}
                                                {item.status === 5 && <span className="badge bg-success">Approved</span>}
                                                {item.status === 0 && <span className="badge bg-danger">Rejected</span>}
                                            </td>
                                        </tr>
                                    ))
                                ) : noDataFound ? (
                                    <tr>
                                        <td colSpan="10" style={{ textAlign: "center", color: "#888" }}>
                                            No Shift Requests Found.
                                        </td>
                                    </tr>
                                ) : null}
                            </tbody>


                        </table>
                    </div>
                </div>
            </div>
        </>
    );
};